import { render, staticRenderFns } from "./TwTiptapEditor.vue?vue&type=template&id=609975de&scoped=true&"
import script from "./TwTiptapEditor.vue?vue&type=script&lang=js&"
export * from "./TwTiptapEditor.vue?vue&type=script&lang=js&"
import style0 from "./TwTiptapEditor.vue?vue&type=style&index=0&id=609975de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609975de",
  null
  
)

export default component.exports